import Blue from "~/core";

new Blue({
  name: 'Youtube Video Embed',
  selector: ".video-player--thumbnail.is-active",
  setup(video) {
    const youtubeId = video.getAttribute('data-id')
    const videoInner = video.querySelector('.video-player__video')
    const thumbnail = `<button class="video-player__play"></button>`;
    const videoFrame = `<iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>`

    videoInner.insertAdjacentHTML('beforeend', thumbnail)
    this.$addEvents(videoInner.children[1], 'click', function() {
      videoInner.innerHTML = videoFrame
    })
  }
});